export const FAN_ID_SCHITTS_CREEK = '5345' as const;
export const FAN_ID_BOB_ROSS = '10482' as const;
export const FAN_ID_DUNE = '5922' as const;
export const FAN_ID_ASSASSINS_CREED = '7981' as const;

export const famPropertyDisplayOrder = [
  FAN_ID_DUNE,
  FAN_ID_SCHITTS_CREEK,
  FAN_ID_ASSASSINS_CREED,
  FAN_ID_BOB_ROSS,
] as const;

export const firstFamProperty = famPropertyDisplayOrder[0];

export const FAM_PROPERTIES = {
  [FAN_ID_SCHITTS_CREEK]: { viewAllPath: '/shop/schitts+creek' },
  [FAN_ID_BOB_ROSS]: { viewAllPath: '/shop?query=bob%20ross&ref=search_box' },
  [FAN_ID_DUNE]: { viewAllPath: '/shop/dune' },
  [FAN_ID_ASSASSINS_CREED]: { viewAllPath: '/shop/assassins+creed' },
} as const;
